import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {

  constructor(public auth: AuthService, public router: Router) {}
  canActivate(): boolean {
    // tslint:disable-next-line: one-line
    if (this.auth.isAuthenticated()){
      return true;
    }
    // tslint:disable-next-line: one-line
    else {
      this.router.navigateByUrl('auth');
      return false;
      // tslint:disable-next-line: comment-format
      //return true
    }
  }
}
